import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211 } from "@faire/web-api--source/indigofair/settings/SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211";

export const useSettingSoftCreditCheckForHigherTerms = () =>
  useSetting(SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211, false);

export const useAssignSettingSoftCreditCheckForHigherTerms = () =>
  useAssignSetting(SOFT_CREDIT_CHECK_FOR_HIGHER_TERMS_V2_250211);
